import SelaTranscriptDefault from './component.jsx'
export default SelaTranscriptDefault
